if ($(window).width() < 600) {
  for(let i = 0; i < $('.svg').length; i++) {
    let src = $($('.svg')[i]).attr('src').split('.svg')[0];
    $($('.svg')[i]).attr('src', src + '-mobile.svg');
  }
}